import { Switch, Route } from 'react-router-dom'
import { PrivateRoute } from './privateRoute'

//Inove Clube Main Page
import { Main } from '../pages/main'

//Public Pages
import { Login } from '../pages/login'
import { RegisterDatasPerson } from '../pages/registerDatasPerson'
import { RegisterAddressPerson } from '../pages/registerAddressPerson'
import { Recover } from '../pages/Recover'
import { RecoverPassword } from '../pages/recoverPassword'
import { AdministrativePanel } from '../pages/administrativePanel'
import { IndividualMarketPlace } from '../pages/individualMarketPlace'
import { Wholesale } from '../pages/Wholesale'
import { Menu } from '../menus/Menu'

//Private Pages
import { Profile } from '../pages/profile'
import { EditProfile } from '../pages/editProfile'
import { Address } from '../pages/address'
import { Orders } from '../pages/orders'
import { ShoppingScreen } from '../shopping'
import { UserCardRegister } from '../pages/userCardRegister'
import { Cards } from '../pages/cards'
import {Analysis} from '../pages/analysis'
import {OldCompanies} from '../pages/oldCompanies'
import {Products} from '../pages/products'

//Undefined Routes
import { RouteUndefined } from '../routeUndefined'

import { Test } from '../test'


const Routes = () => (
    <Switch>
        <Route path='/' exact component={Main}/>
        <Route path='/menu/:business' component={Menu}/>
        <Route path='/store/:matrixBusiness' component={IndividualMarketPlace} />
        <Route path='/login' component={Login} />
        <Route path='/register' component={RegisterDatasPerson} />
        <Route path='/registeraddress' component={RegisterAddressPerson} />
        <Route path='/password/:token' component={RecoverPassword} />
        <Route path='/recover' component={Recover} />
        <Route path='/b2b/:business/:cnpj' component={Wholesale} />
        <PrivateRoute path='/cards' component={Cards} /> 
        <PrivateRoute path='/cardregister' component={UserCardRegister} />
        <PrivateRoute path='/shopping' component={ShoppingScreen} /> 
        <PrivateRoute path='/profile' component={Profile} />
        <PrivateRoute path='/address' component={Address} />
        <PrivateRoute path='/editprofile' component={EditProfile} />
        <PrivateRoute path='/orders' component={Orders} />
        <PrivateRoute path='/adm' component={AdministrativePanel}/>
        <PrivateRoute path='/products' component={Products}/>
        <PrivateRoute path='/analysis' component={Analysis}/>
        <PrivateRoute path='/oldCompanies' component={OldCompanies}/>
        <Route path={process.env.REACT_APP_DEVELOPMENT ? '/test' : ''} component={Test} /> 
        <Route path='*' component={RouteUndefined}/>
    </Switch>
);

export default Routes